
































import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import NavigationLink from '../components/Common/NavigationLink.vue';
import Button from '../components/UI/Button.vue';

@Component({
  components: {
    NavigationLink,
    Button,
  },
})
export default class About extends Mixins(View) {}
